import React, { useState, useEffect } from "react";
import styled from "styled-components";

import Slider from "@material-ui/core/Slider";

import { Row, Text, HGap } from "../../../comps";

const Wrapper = styled(Row)`
  width: 100%;
  align-items: center;
`;

export default ({
  playbackCovered: cov,
  playbackLength,
  seeker,
  isPlaying,
  time: timeStamp,
}) => {
  const [seconds, setSeconds] = useState(Math.floor(cov));
  const [isActive, setActive] = useState(isPlaying);

  useEffect(() => {
    let interval = null;
    if (isPlaying) {
      interval = setInterval(() => {
        const newSec =
          (cov || 0) +
          (new Date().getTime() - (timeStamp || new Date().getTime())) / 1000;
        setSeconds(newSec);
      }, 100);
    } else if (!isPlaying && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isPlaying, seconds]);

  const secToString = (val) => {
    if (!val) return "00:00";
    val = Math.floor(val);
    let hr, min, sec;
    min = Math.floor(val / 60);
    sec = Math.floor(val % 60);
    if (min >= 60) {
      hr = Math.floor(min / 60);
      min = Math.floor(hr % 60);
    }
    hr = hr && (hr < 10 ? "0" + hr : hr);
    min = min < 10 ? "0" + min : min;
    sec = sec < 10 ? "0" + sec : sec;
    return (hr ? hr + ":" : "") + min + ":" + sec;
  };

  const handleChange = (event, val) => {
    setSeconds(Math.floor(val));
    seeker(Math.floor(val));
  };

  return (
    <Wrapper>
      <Text fontSize={`12px`} marginLeft={"1%"} marginRight={"1%"}>
        {secToString(seconds)}
      </Text>
      <HGap width="3%" />
      <Slider
        min={0}
        max={playbackLength}
        value={seconds}
        onChange={handleChange}
        aria-labelledby="continuous-slider"
        style={{ color: `#fff` }}
      />
      <HGap width="3%" />
      <Text fontSize={`12px`} marginLeft={"1%"} marginRight={"1%"}>
        {secToString(playbackLength)}
      </Text>
    </Wrapper>
  );
};
